function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { formatUrl } from 'url-lib';
import noop from 'lodash/noop';
import includes from 'lodash/includes';
import gettext from 'js-utils/gettext';
import { setWindowLocation } from 'js-utils/http';
import Button from 'eventbrite_design_system/button/Button';
import { isSmallDown } from 'eventbrite_design_system/utils/mediaQueries';
import { setAction } from '../utils/userActionCookieHelper';
import './onboardingEntry.scss';
var ONBOARDING_PATH = '/u/interests/';
var IMG_MAP = {
  mobile: 'https://cdn.evbstatic.com/s3-build/perm_001/f8aabe/django/images/onboarding/mobile_entry.jpg',
  standard: 'https://cdn.evbstatic.com/s3-build/perm_001/9c951d/django/images/onboarding/desktop_entry.jpg',
  standardPurple: 'https://cdn.evbstatic.com/s3-build/perm_001/ad8d44/django/images/onboarding/desktop_entry_2.jpg',
  wide: 'https://cdn.evbstatic.com/s3-build/perm_001/c7e0b0/django/images/onboarding/desktop_entry_wide.jpg',
  confirmation: 'https://cdn.evbstatic.com/s3-build/perm_001/7f5101/django/images/onboarding/confirmation_wide.jpg'
};

var OnboardingEntry =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(OnboardingEntry, _Component);

  function OnboardingEntry(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "_getImgSrc", function () {
      var type = _this.props.type;
      var isMobileEntry = _this.state.isMobileEntry;

      if (isMobileEntry) {
        return IMG_MAP.mobile;
      }

      return IMG_MAP[type];
    });

    _defineProperty(_assertThisInitialized(_this), "_getHref", function () {
      var _this$props = _this.props,
          isAuthenticated = _this$props.isAuthenticated,
          referrer = _this$props.referrer;
      var href = formatUrl(ONBOARDING_PATH, {
        'onboarding_referrer': referrer || null
      });

      if (!isAuthenticated) {
        href = "/signin/confirmation/?referrer=/u/interests/?onboarding_referrer=" + referrer;
      }

      return href;
    });

    _defineProperty(_assertThisInitialized(_this), "_handleButtonClick", function () {
      var _this$props2 = _this.props,
          onButtonClick = _this$props2.onButtonClick,
          isAuthenticated = _this$props2.isAuthenticated;

      if (!isAuthenticated) {
        _this._setLoggedOutActionCookie();
      }

      onButtonClick();
      setWindowLocation(_this._getHref());
    });

    _defineProperty(_assertThisInitialized(_this), "_setLoggedOutActionCookie", function () {
      setAction({
        action: 'consumerOnboarding',
        yPos: 0,
        payload: {
          image: IMG_MAP.confirmation,
          title: ''
        }
      });
    });

    _this.state = {
      isMobileEntry: isSmallDown() || props.isMobile
    };
    return _this;
  }

  var _proto = OnboardingEntry.prototype;

  _proto.render = function render() {
    var _classNames;

    var _this$props3 = this.props,
        containerClasses = _this$props3.containerClasses,
        type = _this$props3.type;
    var isMobileEntry = this.state.isMobileEntry;
    var entryPointContainerClasses = classNames('onboarding-entry__container', (_classNames = {}, _classNames[containerClasses] = containerClasses, _classNames['onboarding-entry--standard'] = includes(type, 'standard') && !isMobileEntry, _classNames['onboarding-entry--wide'] = type === 'wide' && !isMobileEntry, _classNames['onboarding-entry--mobile'] = isMobileEntry, _classNames));
    var headerClasses = classNames('onboarding-entry__content__text--header', {
      'eds-text-hs': isMobileEntry,
      'eds-text-hm': !isMobileEntry
    });
    var byLineClasses = classNames('eds-l-pad-bot-2', 'onboarding-entry__content__text--byline', {
      'eds-hide-sm': includes(type, 'standard'),
      'eds-text-bm': !isMobileEntry,
      'eds-text-bs': isMobileEntry
    });
    return React.createElement("div", {
      className: entryPointContainerClasses
    }, React.createElement("section", {
      className: "onboarding-entry"
    }, React.createElement("section", {
      className: "onboarding-entry__content eds-l-pad-right-4"
    }, React.createElement("div", {
      className: "onboarding-entry__content__text"
    }, React.createElement("div", {
      className: headerClasses
    }, gettext('Tell us what you love')), React.createElement("div", {
      className: byLineClasses
    }, gettext('We\'ll find event recomendations just for you'))), React.createElement(Button, {
      type: "link",
      style: "fill",
      onClick: this._handleButtonClick,
      href: this._getHref(),
      __containerClassName: "onboarding-entry__button"
    }, gettext('Get started'))), React.createElement("img", {
      alt: gettext('Personalize your event discovery experience'),
      className: "onboarding-entry__img",
      src: this._getImgSrc()
    })));
  };

  return OnboardingEntry;
}(Component);

_defineProperty(OnboardingEntry, "propTypes", {
  isAuthenticated: PropTypes.bool,
  onButtonClick: PropTypes.func,
  isMobile: PropTypes.bool,
  type: PropTypes.oneOf(['wide', 'standard', 'standardPurple']),
  referrer: PropTypes.string,
  containerClasses: PropTypes.string
});

_defineProperty(OnboardingEntry, "defaultProps", {
  type: 'standard',
  onButtonClick: noop,
  referrer: '/'
});

export { OnboardingEntry as default };